import { isValidUserGroup } from '@loc/helpers/src/userGroup/helpers/isValidUserGroup'

import { useIsMounted } from '../isMounted'

import { getPlanGroupByUserGroup } from './helpers/getPlanGroupByUserGroup'
import { UserTag } from './type'
import { useCookieUserGroup } from './cookieUserGroup'
import { getCookieUserGroup } from './helpers/getCookieUserGroup'
import { createUserGroup } from './helpers/createUserGroup'

import type { IBasicPlanGroupMapping } from './type'

import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'


import { useEffect, useMemo } from 'react';
/**
 * @description: userGroup 与tag 的映射关系
 */
export const userGroupMapping: Record<UserTag, IBasicPlanGroupMapping> = {
  [UserTag.A]: {
    range: [101, 110],
    tag: UserTag.A,
  },
  [UserTag.B]: {
    range: [111, 120],
    tag: UserTag.B,
  },
  [UserTag.C]: {
    range: [121, 130],
    tag: UserTag.C,
  },
  [UserTag.D]: {
    range: [131, 140],
    tag: UserTag.D,
  },
  [UserTag.E]: {
    range: [141, 150],
    tag: UserTag.E,
  },
  [UserTag.F]: {
    range: [151, 160],
    tag: UserTag.F,
  },
}

export function getUserTagByUserGroup(userGroup: string) {
  return getPlanGroupByUserGroup({
    userGroup,
    planGroupMapping: userGroupMapping,
  })
}

export function useUserGroup({ initUserGroup }: { initUserGroup?: string }) {
  const { isSignIn, sessionLoading } = useSessionInfo()
  const { updateCookieUserGroup } = useCookieUserGroup()

  useEffect(() => {
    if (sessionLoading) {
      return
    }
    const cookieUserGroup = getCookieUserGroup()
    const group = createUserGroup()

    /* 客户端组别不是101-160，更新101-160 */
    if (cookieUserGroup && !isValidUserGroup(`${cookieUserGroup}`)) {
      updateCookieUserGroup(group)
      return
    }

    /* 未登录，且没有组 */
    if (!isSignIn && !cookieUserGroup) {
      updateCookieUserGroup(group)
      return
    }
    /* 已登录，还没有组 */
    if (isSignIn && !initUserGroup && !cookieUserGroup) {
      updateCookieUserGroup(group)
      return
    }
    /* 已登录，有组 */
    if (isSignIn && initUserGroup && isValidUserGroup(`${initUserGroup}`)) {
      updateCookieUserGroup(initUserGroup)
    }
  }, [isSignIn, sessionLoading, initUserGroup])

  const { isMounted } = useIsMounted()

  const userGroup = useMemo(() => {
    if (isMounted) {
      const group = createUserGroup()
      const cookieUserGroup = getCookieUserGroup() as string
      if (!cookieUserGroup || !isValidUserGroup(`${cookieUserGroup}`)) {
        updateCookieUserGroup(group)
      }
      return initUserGroup || cookieUserGroup || group
    }
    return initUserGroup || '101'
  }, [initUserGroup, isMounted])

  const userTag = getUserTagByUserGroup(userGroup)

  return { userGroup, userTag }
}
